import React from 'react'
import { Dashboard } from '@newspacebpo/mf_protocolo_bfveic'
const DashboardPage = (props) => {
    return (
            <Dashboard {...props}/>
    );
};

export { DashboardPage };